import React, { useState } from "react";
import "../Styles/Contact.css";
import Footer from "./Footer";

function Contact() {
  const [formData, setFormData] = useState({ cuname: "", coname: "", conumber: "", cuemail: "", cuabout: "" });
  const [formErrors, setFormErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setFormErrors({ ...formErrors, [e.target.name]: "" });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.cuname.trim()) errors.cuname = "Name is required";
    if (!formData.coname.trim()) errors.coname = "Company name is required";
    if (!formData.conumber.trim()) errors.conumber = "Contact number is required";
    else if (!/^\d+$/.test(formData.conumber.trim())) errors.conumber = "Contact number must contain only numbers";
    else if (formData.conumber.trim().length !== 10) errors.conumber = "Contact number must be 10 digits";
    if (!formData.cuemail.trim()) errors.cuemail = "Email is required";
    else if (!/\S+@\S+\.\S+/.test(formData.cuemail.trim())) errors.cuemail = "Invalid email address";
    if (!formData.cuabout.trim()) errors.cuabout = "Please describe your requirement";
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setIsLoading(true);
    try {
      const response = await fetch("https://rox0oo6f4k.execute-api.ca-central-1.amazonaws.com/sendEmail", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (response.status === 200) {
        alert("Form submitted successfully!");
        setFormData({ cuname: "", coname: "", conumber: "", cuemail: "", cuabout: "" });
      } else {
        alert("Error submitting form. Please try again later.");
      }
    } catch {
      alert("Network error. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="page-hero">
        <h1>CONTACT US</h1>
        <div className="section-divider"></div>
      </div>

      {isLoading && <div className="loader-container"><div className="loader"></div></div>}

      <div className={`contact-layout ${isLoading ? "blur" : ""}`}>
        <div className="form-card">
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-field">
              <label htmlFor="cuname">Your Name</label>
              <input type="text" placeholder="John Smith" id="cuname" name="cuname" value={formData.cuname} onChange={handleChange} />
              {formErrors.cuname && <span className="error">{formErrors.cuname}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="coname">Company Name</label>
              <input type="text" placeholder="Acme Corp" id="coname" name="coname" value={formData.coname} onChange={handleChange} />
              {formErrors.coname && <span className="error">{formErrors.coname}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="conumber">Phone Number</label>
              <input type="text" placeholder="5191234567" id="conumber" name="conumber" value={formData.conumber} onChange={handleChange} />
              {formErrors.conumber && <span className="error">{formErrors.conumber}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="cuemail">Email Address</label>
              <input type="text" placeholder="you@company.com" id="cuemail" name="cuemail" value={formData.cuemail} onChange={handleChange} />
              {formErrors.cuemail && <span className="error">{formErrors.cuemail}</span>}
            </div>
            <div className="form-field">
              <label htmlFor="cuabout">Your Requirement</label>
              <textarea placeholder="Describe your project or inquiry..." id="cuabout" name="cuabout" value={formData.cuabout} onChange={handleChange} rows={4}></textarea>
              {formErrors.cuabout && <span className="error">{formErrors.cuabout}</span>}
            </div>
            <input type="submit" value={isLoading ? "Sending..." : "Send Message"} disabled={isLoading} />
          </form>
        </div>

        <div className="info-card">
          <div className="info-block">
            <h3>CONTACT INFO</h3>
            <p>
              <strong style={{ color: "#fff" }}>Windsor Precision Works</strong><br />
              6240 Hawthorne Drive<br />
              Windsor, ON N8T 1J9<br />
              Canada<br /><br />
              +1 519 800-8080<br />
              <a href="mailto:info@precisionworks.ca">info@precisionworks.ca</a>
            </p>
          </div>
          <div className="info-block">
            <h3>LOCATE US</h3>
            <div className="map-wrapper">
              <iframe
                title="Google Maps Locator"
                style={{ width: "100%", height: "100%", minHeight: "200px", display: "block" }}
                src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=6240+Hawthorne+Dr,+Windsor,+ON+N8T+1J9,+Canada&t=&z=16&ie=UTF8&iwloc=B&output=embed"
              ></iframe>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

export default Contact;
